import React, { useState, useEffect, useRef, useContext } from "react";
import cn from "classnames";
import { Message_data } from "../context/context.js";
import { db, db2, auth, storage } from "../firebase-config.js";
import {
  doc,
  getDoc,
  addDoc,
  setDoc,
  updateDoc,
  collection,
  onSnapshot,
  query,
  serverTimestamp,
  where,
  orderBy,
} from "firebase/firestore";

import "../styles/Chat.scss";
import WhatsOn from "./WhatsOn";

export const ClientInfo = ({
  userObj,
  clientObj,
  openJukeboxPlaylist,
  showChatlist,
}) => {
  // State for carousel functionality
  const [currentImageIndex, setCurrentImageIndex] = useState({});
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  
  // Helper function to convert 24-hour time to 12-hour format with AM/PM
  const convertTo12Hour = (time24) => {
    if (!time24) return '';
    
    // Split the time into hours and minutes
    const [hours, minutes] = time24.split(':');
    const hour = parseInt(hours);
    
    // Determine AM or PM
    const period = hour >= 12 ? 'PM' : 'AM';
    
    // Convert to 12-hour format
    let hour12 = hour % 12;
    if (hour12 === 0) hour12 = 12;
    
    // Return formatted time
    return `${hour12}:${minutes} ${period}`;
  };
  // Get venue info with fallbacks
  const venueName = clientObj?.venueInfo?.name || clientObj?.id || "Your Venue";
  const venueDescription = clientObj?.venueInfo?.description || "";
  const venueAddress = clientObj?.venueInfo?.address || "";
  const venueCity = clientObj?.venueInfo?.city || "";
  const venueState = clientObj?.venueInfo?.state || "";
  const venueZip = clientObj?.venueInfo?.zipCode || "";
  const venuePhone = clientObj?.venueInfo?.phone || "";
  const venueEmail = clientObj?.venueInfo?.email || "";
  const venueWebsite = clientObj?.venueInfo?.website || "";
  const venueBanner = clientObj?.venueInfo?.bannerImage || "";
  const venueAvatar = clientObj?.avatarImage || "";
  const venueEvents = clientObj?.events || [];
  const venueSocial = clientObj?.venueInfo?.socialMedia || {};
  const venueHours = clientObj?.venueInfo?.hours || {};
  const chatbase = useRef(null);
  const { message, setMessage } = useContext(Message_data);
  const [jukebox, setJukebox] = useState([]);
  const jukeboxRef = collection(db2, "jukebox");

  // Carousel navigation functions
  const handlePrevious = (eventId, totalImages) => {
    setCurrentImageIndex(prev => ({
      ...prev,
      [eventId]: prev[eventId] === 0 || prev[eventId] === undefined 
        ? totalImages - 1 
        : prev[eventId] - 1
    }));
  };

  const handleNext = (eventId, totalImages) => {
    setCurrentImageIndex(prev => ({
      ...prev,
      [eventId]: prev[eventId] === undefined 
        ? 1 
        : (prev[eventId] + 1) % totalImages
    }));
  };

  // Touch event handlers for swipe
  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = (eventId, totalImages) => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      handleNext(eventId, totalImages);
    }
    if (isRightSwipe) {
      handlePrevious(eventId, totalImages);
    }
  };

  useEffect(() => {
    const playerControlData = async () => {
      if (message) {
        const data = JSON.parse(message);
        if (data.viewNextSong) {
          console.log("data.viewNextSong", data.viewNextSong);
          // viewNextTrack();

          //   const idx = jukebox.findIndex((item) => item.id === currentSongId);
          //   if (idx !== -1) {
          //     console.log("current jukebox track and index", jukebox[idx], idx);
          //     console.log("next song id is", jukebox[idx + 1]);
          //     setNextTrack(jukebox[idx + 1]);
          //     setShowNextTrackModal(true);
          //   }
        }
      }
    };
    playerControlData();
  }, [message]);

  return (
    <>
      <div className="flex flex-col overflow-x-auto mb-4 manuf-scrollable-section">
        <div className="flex flex-row  h-full">
          <div className="tab-content active" id="home">
            <h2>
              Welcome to {venueName}
              <br />
              Powered by Muuzbox
            </h2>

            {/* What's On — events + promotions the venue publishes from the
                admin Event Calendar / Promotions surfaces. Renders nothing
                when the venue has published nothing. */}
            <WhatsOn clientObj={clientObj} />

            {/* Venue Description */}
            {venueDescription && (
              <div className="post text-left text-white mb-4">
                <img src={venueBanner} alt="Venue Banner" className="w-full h-auto mb-4" />
                <p className="text-white">{venueDescription}</p>
              </div>
            )}

            {/* Venue Contact Info */}
            {(venueAddress || venuePhone || venueEmail) && (
              <div className="post text-left text-white">
                <p className="title text-white">
                  <strong>Contact Us</strong>
                </p>
                {venueAddress && (
                  <p className="">📍 {venueAddress}{venueCity && `, ${venueCity}`}{venueState && `, ${venueState}`}{venueZip && ` ${venueZip}`}</p>
                )}
                {venuePhone && <p className="">📞 {venuePhone}</p>}
                {venueEmail && <p className="">✉️ {venueEmail}</p>}
                {venueWebsite && (
                  <p className="text-base">
                    🌐 <a href={venueWebsite} target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300">
                      {venueWebsite.replace(/^https?:\/\//, '')}
                    </a>
                  </p>
                )}
              </div>
            )}

            <div className="post text-left text-white">
              <p className="title  text-white">
                <strong>How to Use MUUZBOX:</strong>
              </p>
              <ul className="list-disc text-left ml-4">
                <li className="text-left">
                  Home: See what's trending and & updates
                </li>
                <li className="text-left">
                  Now Playing: Current playlist + vote on upcoming tracks
                </li>
                <li className="text-left">
                  Request: Search & request any song you want
                </li>
                <li className="text-left">
                  Chats: Talk music with other guests
                </li>
                <li className="text-left">
                  Profile: Manage your account & preferences
                </li>
              </ul>
            </div>

            {/* Dynamic Events Display */}
            {venueEvents && venueEvents.length > 0 && (
              <>
                <div className="post text-left text-white">
                  <p className="title text-white">
                    <strong>Upcoming Events</strong>
                  </p>
                </div>
                {venueEvents.map((event, index) => {
                  const eventId = event.id || index;
                  const currentIndex = currentImageIndex[eventId] || 0;
                  const hasMultipleImages = event.posterUrls && event.posterUrls.length > 1;
                  
                  return (
                    <div key={eventId} className="post">
                      {event.posterUrls && event.posterUrls.length > 0 && (
                        <div className="relative overflow-hidden rounded mb-2">
                          <div 
                            className="relative"
                            onTouchStart={handleTouchStart}
                            onTouchMove={handleTouchMove}
                            onTouchEnd={() => handleTouchEnd(eventId, event.posterUrls.length)}
                          >
                            <img
                              src={event.posterUrls[currentIndex]}
                              alt={`${event.name} poster ${currentIndex + 1}`}
                              className="w-full transition-opacity duration-300"
                            />
                            
                            {/* Navigation arrows - only show if multiple images */}
                            {hasMultipleImages && (
                              <>
                                <button
                                  onClick={() => handlePrevious(eventId, event.posterUrls.length)}
                                  className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full opacity-60 hover:opacity-100 md:opacity-0 md:hover:opacity-100 transition-opacity text-xl font-bold w-10 h-10 flex items-center justify-center"
                                  aria-label="Previous image"
                                >
                                  ‹
                                </button>
                                <button
                                  onClick={() => handleNext(eventId, event.posterUrls.length)}
                                  className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full opacity-60 hover:opacity-100 md:opacity-0 md:hover:opacity-100 transition-opacity text-xl font-bold w-10 h-10 flex items-center justify-center"
                                  aria-label="Next image"
                                >
                                  ›
                                </button>
                                
                                {/* Image indicators */}
                                <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1">
                                  {event.posterUrls.map((_, imgIndex) => (
                                    <button
                                      key={imgIndex}
                                      onClick={() => setCurrentImageIndex(prev => ({ ...prev, [eventId]: imgIndex }))}
                                      className={`w-2 h-2 rounded-full transition-all ${
                                        imgIndex === currentIndex 
                                          ? 'bg-white w-6' 
                                          : 'bg-white/50 hover:bg-white/75'
                                      }`}
                                      aria-label={`Go to image ${imgIndex + 1}`}
                                    />
                                  ))}
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      )}
                      <p className="text-3xl font-bold text-white">{event.name}</p>
                      {event.date && event.startTime && (
                        <p className="text-gray-300">
                          {event.date} • {convertTo12Hour(event.startTime)}
                          {event.endTime && ` - ${convertTo12Hour(event.endTime)}`}
                        </p>
                      )}
                      {event.description && (
                        <p className="text-gray-300 mt-1">{event.description}</p>
                      )}
                      {event.ticketPrice && (
                        <p className="text-yellow-400 mt-1">
                          Tickets: ${event.ticketPrice}
                        </p>
                      )}
                    </div>
                  );
                })}
              </>
            )}

            {/* Operating Hours */}
            {/* {venueHours && Object.keys(venueHours).length > 0 && (
              <div className="post text-left text-white">
                <p className="title text-white">
                  <strong>Hours of Operation</strong>
                </p>
                <div className=" space-y-1">
                  {Object.entries(venueHours).map(([day, hours]) => (
                    <div key={day} className="capitalize">
                      {day}: {hours.closed ? 'Closed' : `${hours.open || 'N/A'} - ${hours.close || 'N/A'}`}
                    </div>
                  ))}
                </div>
              </div>
            )} */}

            {/* Social Media Links */}
            {venueSocial && Object.keys(venueSocial).some(key => venueSocial[key]) && (
              <div className="post text-left text-white">
                <p className="title text-white">
                  <strong>Follow Us</strong>
                </p>
                <div className="flex gap-4 mt-2">
                  {venueSocial.facebook && (
                    <a href={`https://${venueSocial.facebook.replace(/^https?:\/\//, '')}`} 
                       target="_blank" 
                       rel="noopener noreferrer"
                       className="text-blue-400 hover:text-blue-300">
                      Facebook
                    </a>
                  )}
                  {venueSocial.instagram && (
                    <a href={`https://instagram.com/${venueSocial.instagram.replace('@', '')}`} 
                       target="_blank" 
                       rel="noopener noreferrer"
                       className="text-pink-400 hover:text-pink-300">
                      Instagram
                    </a>
                  )}
                  {venueSocial.twitter && (
                    <a href={`https://twitter.com/${venueSocial.twitter.replace('@', '')}`} 
                       target="_blank" 
                       rel="noopener noreferrer"
                       className="text-blue-400 hover:text-blue-300">
                      Twitter
                    </a>
                  )}
                </div>
              </div>
            )}

            <div className=" post text-left text-white">
              🎧 Top voted song: "Blinding Lights" - The Weeknd
            </div>
            <div className="post text-left text-white">
              🎵 Join the community and vote for your favorite tracks!
            </div>
            <div className="post text-left text-white">
              🚀 New features coming soon - stay tuned!
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
